import Service from "../../Service";
const resource = "SpcCarrier/";

export default {
  pagination(parameters, requestID) {
    return Service.post(resource + "pagination", parameters, {
      params: { requestID: requestID },
    });
  },

  list(parameters, requestID) {
    return Service.post(resource + "list", parameters, {
      params: { requestID },
    });
  },

  save(prd, requestID) {
    return Service.post(resource + "save", prd, {
      params: { requestID: requestID },
    });
  },
};
